<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role ==='ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role ==='ACCOUNT_OWNER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role ==='AO_SELLER'"><a routerLink="/admin/sellerDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Package Types</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Package Type Details</h2>
          <div class="row mt-3">
            <div class="col-md-12 col-md-8">
              <div class="row">
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="packageType">Package Type</label>
                    <input type="text" id="packageType" [(ngModel)]="packageType" class="form-control"
                           (blur)="typePackage()" [ngClass]="{'is-invalid':statusText1}"
                           [ngModelOptions]="{standalone: true}" required>
                    <div id="statusText1" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText1">
                      {{statusText1}}
                    </div>
                  </div>
                </div>
                <div class="col col-md-2 required">
                  <div class="form-group ">
                    <label class="control-label" for="length">Length (in cms)</label>
                    <input type="text" id="length" [(ngModel)]="boxLength" [ngModelOptions]="{standalone: true}"
                           class="form-control" (blur)="typeLength()" [ngClass]="{'is-invalid':statusText2}"
                           onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                           required>
                    <div id="statusText2" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText2">
                      {{statusText2}}
                    </div>
                  </div>
                </div>
                <div class="col-auto align-self-center">
                  <div class="form-group">*</div>
                </div>
                <div class="col col-md-2 required">
                  <div class="form-group ">
                    <label class="control-label" for="width">Width (in cms)</label>
                    <input type="text" id="width" [(ngModel)]="boxWidth" [ngModelOptions]="{standalone: true}"
                           onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                           class="form-control" (blur)="typeWidth()" [ngClass]="{'is-invalid':statusText3}" required>
                    <div id="statusText3" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText3">
                      {{statusText3}}
                    </div>
                  </div>
                </div>
                <div class="col-auto align-self-center">
                  <div class="form-group">*</div>
                </div>
                <div class="col col-md-2 required">
                  <label class="control-label" for="height">Height (in cms)</label>
                  <div class="form-group ">
                    <input type="text" id="height" [(ngModel)]="boxHeight" [ngModelOptions]="{standalone: true}"
                           onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                           class="form-control" (blur)="typeHeight()" [ngClass]="{'is-invalid':statusText4}" required>
                    <div id="statusText4" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText4">
                      {{statusText4}}
                    </div>
                  </div>
                </div>
<!--
                <div class="text-center" style="padding:33px"> (in cms)</div>
-->
              <div class="row">
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="weight">Weight (in Kg's) </label>
                    <input type="text" id="weight" [(ngModel)]="weight" class="form-control" (blur)="typeWeight()"
                           [ngClass]="{'is-invalid':statusText5}" [ngModelOptions]="{standalone: true}"
                           onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                           required>
                    <div id="statusText5" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText5">
                      {{statusText5}}
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 text-right">
        <button type="reset" (click)="clearPackage()" id="clear" class="btn btn-cancel-prime">Clear</button>
        <button type="submit" class="btn btn-orange-prime ml-2" id="add" (click)="submitPackage()">Add</button>
      </div>
    </div>

    <div class="row mt-3" [hidden]="!package?.length ">
      <div class="col">
        <div class="inner-box" style="overflow:overlay;">
          <table class="table table-stripe">
            <thead>
            <tr>
              <th>Package Type</th>
              <th>Length (in cms)</th>
              <th>Width (in cms)</th>
              <th>Height (in cms)</th>
              <th>Weight (in Kg's)</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let p of package">
              <td>{{p.packingType}}</td>
              <td>{{p.length}}</td>
              <td>{{p.width}}</td>
              <td>{{p.height}}</td>
              <td>{{p.weight}}</td>
              <td><a data-toggle="modal" data-target="#deletePackage" (click)="selectedDeleteReturn(p)">
                <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                  <defs>
                    <style>.a {
                      fill: #848484;
                    }</style>
                  </defs>
                  <path class="a"
                        d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                        transform="translate(-7.5 -4.5)"/>
                </svg>
              </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
</section>


<div class="modal fade" id="deletePackage" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Confirmation</h4>
        <button type="button" id="close" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <p>Do you really want to delete ? </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-delete" id="no" data-dismiss="modal">No</button>
        <button type="button" class="btn btn-edit ml-2" id="yes" data-dismiss="modal" (click)="deletePackage()">Yes
        </button>
      </div>
    </div>
  </div>
</div>
